import * as runtime from '@/api/runtime'
import {
  BatchSchoolStatisticsLendRequest,
  BatchSchoolStatisticsLendRequestToJSON
} from '@/api/models/batch'

import {
  BatchStatisticsGetSelectItemResult,
  BatchStatisticsGetSelectItemResultFromJSON
} from '@/api/models/batch/BatchStatisticsGetSelectItemResult'

/**
 * 学校統計(貸出)
 */
export class BatchSchoolStatisticsLendApi extends runtime.BaseAPI {
  // 帳票出力
  async createLend(request: BatchSchoolStatisticsLendRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/school-statistics/lend`,
      BatchSchoolStatisticsLendRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  // 定義登録
  async registerPattern(
    request: BatchSchoolStatisticsLendRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestPost(
      `/batch/school-statistics/register_lend_pattern`,
      BatchSchoolStatisticsLendRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }
}
